import { render, staticRenderFns } from "./JXCGenerateVoucherPreview.vue?vue&type=template&id=ff6c3792&scoped=true"
import script from "./JXCGenerateVoucherPreview.vue?vue&type=script&lang=js"
export * from "./JXCGenerateVoucherPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6c3792",
  null
  
)

export default component.exports